import { useMemo } from 'react';
import { useFormDataContext } from 'modules/taboola-common-frontend-modules/formData';
import { useFetchedCampaignGroup } from '../CampaignGroupField/hooks/useFetchedCampaignGroup';

export const useMarketingObjectiveDependencies = () => {
    const { data } = useFormDataContext();
    const selectedCampaignGroupId = data.campaignGroupInfo?.campaignGroupId;
    const campaignGroup = useFetchedCampaignGroup(selectedCampaignGroupId);
    const campaignGroupMarketingObjective = campaignGroup?.marketingObjective;

    const campaignGroupMarketingObjectiveMemoized = useMemo(() => {
        return { campaignGroupMarketingObjective };
    }, [campaignGroupMarketingObjective]);

    return campaignGroupMarketingObjectiveMemoized;
};
